import { MenuItem } from 'primeng/api';

/**
 * Filters a single MenuItem based on canAccess permission and visible subitems
 */
export function filterSingleItem(item: MenuItem): MenuItem | undefined {
  // Recursively filter subitems if they exist
  if (item.items && item.items.length > 0) {
    item.items = filterMenuItemsArray(item.items);
  }

  const hasPermission = item['canAccess'] === undefined || item['canAccess'] === true;
  const hasVisibleSubItems = !item.items || item.items.length > 0;

  return hasPermission && hasVisibleSubItems ? item : undefined;
}

/**
 * Filters an array of MenuItems
 */
export function filterMenuItemsArray(items: MenuItem[]): MenuItem[] {
  return items.map(filterSingleItem).filter((item): item is MenuItem => item !== undefined);
}
